import { render } from "./TvmUpgradeVehicle.vue?vue&type=template&id=6536283c&scoped=true"
import script from "./TvmUpgradeVehicle.vue?vue&type=script&lang=js"
export * from "./TvmUpgradeVehicle.vue?vue&type=script&lang=js"

import "./TvmUpgradeVehicle.vue?vue&type=style&index=0&id=6536283c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6536283c"],['__file',"src/components/ChatWidget/SlideOutPanel/TvmUpgradeVehicle/TvmUpgradeVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6536283c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6536283c', __exports__)) {
    api.reload('6536283c', __exports__)
  }
  
  module.hot.accept("./TvmUpgradeVehicle.vue?vue&type=template&id=6536283c&scoped=true", () => {
    api.rerender('6536283c', render)
  })

}


export default __exports__